import React from 'react';

const YouMeIcon: React.FC<{ fill: string }> = ({ fill = '#ffffff' }) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    width="19.87"
    height="23.95"
    viewBox="0 0 19.87 23.95"
  >
    <g id="Layer_1-2" data-name="Layer 1">
      <g>
        <path
          fill={fill}
          d="M2.98,8.69C3.97,2.72,12.56.8,15.82,6.27c.2.33,1.07,2.29,1.07,2.42v7.99l-.75.75-1.23-.75v-8.49c0-1.62-3.96-3.44-5.72-3.29-1.55.14-4.22,2.43-4.22,3.79v14.49l-.75.75-1.23-.75c.51-4.4-.69-10.3,0-14.49Z"
        />
        <path
          fill={fill}
          d="M11.92,9.19c-.12-.41-1.21-1.23-1.76-1.27-3.97-.4-1.04,7.59-2.96,8.01s-1.55-7.4-.1-8.85c1.37-1.37,4.31-1.37,5.69,0,.12.12,1.13,1.99,1.13,2.11v13.99l-.75.75-1.23-.75c-.65-3.63.88-10.85,0-13.99Z"
        />
        <path
          fill={fill}
          d="M8.83.08c2.25-.28,6.24.09,7.07,2.61-1.32,1.81-2.88-.32-4.33-.63C7.49,1.19,3.99,3.42,2.46,7.17c-.53,1.29-.02,3.53-1.7,3.77-1.73-.37.23-5.32.75-6.23C2.85,2.31,6.11.41,8.83.08Z"
        />
        <path
          fill={fill}
          d="M19.87,23.18l-1.23.75c-.28-.25-.55-.44-.67-.83-.92-2.94.39-10.7-.07-14.42-.2-1.63-1.06-2.5-1.5-3.97l1.24-.76c.75.18,2.24,4.5,2.24,5.24v13.99Z"
        />
        <polygon
          fill={fill}
          points="0 13.19 .75 12.44 1.99 13.19 1.99 23.18 1.23 23.93 0 23.18 0 13.19"
        />
        <polygon
          fill={fill}
          points="8.94 10.69 9.7 9.95 10.93 10.69 10.93 18.19 10.18 18.93 8.94 18.19 8.94 10.69"
        />
        <path
          fill={fill}
          d="M6.72,17.44c1.87-.39,1.59,6.25.48,6.49-1.87.39-1.59-6.25-.48-6.49Z"
        />
        <path
          fill={fill}
          d="M15.66,18.94c1.76-.37,1.63,4.75.48,4.99-1.76.37-1.63-4.75-.48-4.99Z"
        />
      </g>
    </g>
  </svg>
);

export default YouMeIcon;
